import {Component, OnInit} from "@angular/core";
import {ChannelsService} from "../channels-service.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {Level, Message} from "../../../model/message.component";
import {ActivatedRoute} from "@angular/router";
import {ChannelDefinition} from "../../../model/channels.model";

@Component({
  selector: "admin-channels-view",
  templateUrl: "./view.component.html",
  styleUrls: ["./view.component.css"]
})
export class AdminChannelsViewChannelComponent implements OnInit {

  channel: ChannelDefinition = new ChannelDefinition()

  constructor(
    private service: ChannelsService,
    private viewManager: ViewManagerService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    let owner = this.route.snapshot.paramMap.get("owner")!;
    let vertical = this.route.snapshot.paramMap.get("vertical")!;
    let code = this.route.snapshot.paramMap.get("code")!;

    this.service.view(owner, vertical, code)
      .pipe()
      .subscribe({
        next: (result) => {
          this.channel = result;
          console.log(result);
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

}
